// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"3305c021","769":"5c0e780b"}[chunkId] + ".chunk.js";
};